import axios from "axios";
import { API_BASE_URL } from "../config/apiConfig";

const token = () => localStorage.getItem("authToken");
const headers = () => ({ Authorization: `${token()}` });

// CRUD básico de asignaturas
export const getAsignaturas = async () => {
  const response = await axios.get(`${API_BASE_URL}/asignaturas`, { headers: headers() });
  return response.data.asignaturas;
};

export const createAsignatura = async (data) => {
  const response = await axios.post(`${API_BASE_URL}/asignaturas`, data, { headers: headers() });
  return response.data;
};

export const updateAsignatura = async (id, data) => {
  const response = await axios.put(`${API_BASE_URL}/asignaturas/${id}`, data, { headers: headers() });
  return response.data;
};

export const deleteAsignatura = async (id) => {
  const response = await axios.delete(`${API_BASE_URL}/asignaturas/${id}`, { headers: headers() });
  return response.data;
};

// 🆕 Gestión de asignaciones a salones
export const getAsignaturasConSalones = async () => {
  const response = await axios.get(`${API_BASE_URL}/asignaturas/con-salones`, { headers: headers() });
  return response.data.data;
};

export const asignarAsignaturaSalon = async (data) => {
  const response = await axios.post(`${API_BASE_URL}/asignaturas/asignar-salon`, data, { headers: headers() });
  return response.data;
};

export const actualizarIHAsignaturaSalon = async (asignaturaSalonId, IH) => {
  const response = await axios.put(
    `${API_BASE_URL}/asignaturas/salon/${asignaturaSalonId}/ih`,
    { IH },
    { headers: headers() }
  );
  return response.data;
};

// 🆕 Asignación masiva
export const asignarMasivamente = async (asignaciones) => {
  const response = await axios.post(
    `${API_BASE_URL}/asignaturas/asignar-masivamente`,
    { asignaciones },
    { headers: headers() }
  );
  return response.data;
};

export const eliminarAsignaturaSalon = async (asignaturaSalonId) => {
  const response = await axios.delete(
    `${API_BASE_URL}/asignaturas/salon/${asignaturaSalonId}`,
    { headers: headers() }
  );
  return response.data;
};